module.exports = __webpack_public_path__ + "img/convenience.cc390899.svg";